require('../../modules/es6.symbol');
module.exports = require('../../modules/_core').Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/get-own-property-symbols.js
// module id = 579
// module chunks = 168707334958949